import noop from 'lodash/noop';
import { combineReducers } from 'redux';

import {
  CONFIRM_ACTION_ASK_CONFIRM_ACTION,
  CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL,
  CONFIRM_ACTION_SET_NEXT_ACTION,
  CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL,
  CONFIRM_ACTION_CALLBACK,
} from '../actions/confirm-action/constants';
import createReducer from '../utils/createReducer';

const customText = createReducer('', {
  [CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.customText,
});

const nextAction = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [CONFIRM_ACTION_SET_NEXT_ACTION]: (draft, { payload }) => payload.nextAction,
});

const showConfirmActionModal = createReducer(false, {
  [CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL]: () => true,
  [CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL]: () => false,
});

const isThunk = createReducer(false, {
  [CONFIRM_ACTION_ASK_CONFIRM_ACTION]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isThunk,
});

const callback = createReducer(noop, {
  [CONFIRM_ACTION_CALLBACK]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.callback,
});

export default combineReducers({
  customText,
  nextAction,
  showConfirmActionModal,
  isThunk,
  callback,
});
